import React from "react";
import { Field, ErrorMessage } from "formik";

export default function DonationsComponent({ formik }) {
  return (
    <div
      className="col-12 my-0 rounded-3 p-4"
      style={{
        border: "1px solid #e9ecef",
        backgroundColor: "#fff",
      }}
    >
      <h4 className="fw-bold mb-4">Donations</h4>
      <div className="alert alert-info">
        <p className="mb-0">
          We sincerely value your willingness to contribute. Every donation,
          regardless of size, plays a vital role in supporting the school’s
          development and future initiatives.
        </p>
        <p className="mb-2">
          Please deposit your donations to the following account:
        </p>
        <ul className="mb-0">
          <li>
            <strong>Bank:</strong> Peoples' Bank
          </li>
          <li>
            <strong>SWIFT Code:</strong> PSBKLKLX
          </li>
          <li>
            <strong>Branch:</strong> Galle Main Street
          </li>
          <li>
            <strong>Account Name:</strong> Old Boys Association Vidyaloka
            Vidyalaya
          </li>
          <li>
            <strong>Account Number:</strong> 169100180006180
          </li>
        </ul>
        <p className="mt-2 mb-0">
          The <strong>National Identity Card (NIC) number</strong> must be
          printed on the payment receipt as the{" "}
          <strong>
            reference, reason, remark, receiver’s comment, or narration{" "}
          </strong>
          .
        </p>
      </div>

      <div className="row g-3">
        {/* Donation Date */}
        <div className="col-md-6">
          <label className="form-label">Date</label>
          <Field
            type="date"
            className="form-control"
            name="donation.donationDate"
          />
          <ErrorMessage
            name="donation.donationDate"
            component="div"
            className="text-danger"
          />
        </div>

        {/* Donation Amount */}
        <div className="col-md-6">
          <label className="form-label">Amount (LKR)</label>
          <Field
            type="number"
            step="0.01"
            className="form-control"
            name="donation.donationAmount"
          />
          <ErrorMessage
            name="donation.donationAmount"
            component="div"
            className="text-danger"
          />
        </div>

        {/* Donation Reason */}
        <div className="col-12">
          <label className="form-label">Reason</label>
          <Field
            type="text"
            className="form-control"
            name="donation.donationReason"
          />
          <ErrorMessage
            name="donation.donationReason"
            component="div"
            className="text-danger"
          />
        </div>

        {/* Donation Slip Upload */}
        <div className="col-12 mb-3">
          <label className="form-label">Payment Slip</label>
          <input
            type="file"
            className="form-control"
            name="donationSlip"
            accept=".jpg,.jpeg,.png,.pdf"
            onChange={(e) =>
              formik.setFieldValue("donationSlip", e.currentTarget.files[0])
            }
          />
          {formik.values.donationSlip && (
            <small className="text-success">
              {formik.values.donationSlip.name}
            </small>
          )}
          <ErrorMessage
            name="donationSlip"
            component="div"
            className="text-danger"
          />
        </div>
      </div>
    </div>
  );
}
